import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { Commodity } from './entities';
import { Session } from '@benzinga/session';
import { CommoditiesEnvironment } from './environment';

export class CommoditiesRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(CommoditiesEnvironment).url, session);
  }

  getCommodities = (category: string): SafePromise<Commodity[]> => {
    const url = this.URL(`futures?category=${category}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getCommodity = (symbol: string): SafePromise<Commodity> => {
    const url = this.URL(`futures/${symbol}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
